import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '¿Qué incluye el Kit Completo de Lengua y Literatura?',
  a: 'Incluye material completo de 1° a 6° año con actividades, planificaciones, secuencias didácticas, orientaciones docentes y 3 bonus exclusivos (Guía de Primeros Auxilios, Guía de Planificación Anual y 50 actividades extra).'
}, {
  q: '¿Para qué años o cursos está diseñado?',
  a: 'El kit cubre de 1° a 6° año de secundaria, con contenidos organizados por año y adaptables a distintos diseños curriculares provinciales.'
}, {
  q: '¿Cómo recibo el material después de la compra?',
  a: 'Recibís acceso inmediato por Google Drive. Todo el material está en formato PDF, listo para descargar e imprimir.'
}, {
  q: '¿Puedo adaptar el contenido a mi planificación provincial?',
  a: 'Sí, el material está diseñado para ser flexible y adaptable a cualquier diseño curricular provincial. Muchos docentes lo usan como base y lo ajustan según sus necesidades.'
}, {
  q: '¿Qué diferencia hay entre el Kit Completo y el Pack Premium?',
  a: 'El Kit Completo incluye los contenidos de 1° a 6° año + 3 bonus. El Pack Premium suma además el Maletín de Actividades con 50 actividades extra listas para el aula.'
}, {
  q: '¿El material incluye respuestas para el docente?',
  a: 'Sí, todas las actividades incluyen orientaciones y respuestas docentes para facilitar la corrección y el seguimiento.'
}, {
  q: '¿Tiene vencimiento el acceso al material?',
  a: 'No, el acceso es de por vida. Una vez que comprás, el material es tuyo para siempre, sin suscripciones ni pagos adicionales.'
}, {
  q: '¿Puedo compartir el kit con otros docentes?',
  a: 'La licencia es personal y para uso individual. Si querés que otros colegas lo usen, cada uno debería adquirir su propia copia.'
}, {
  q: '¿Qué pasa si no quedo satisfecho/a con la compra?',
  a: 'Tenés una garantía de satisfacción de 7 días. Si no estás conforme, te devolvemos el 100% de tu dinero sin preguntas.'
}, {
  q: '¿Cómo puedo contactar si tengo dudas antes o después de comprar?',
  a: 'Podés escribirnos por Instagram, WhatsApp o email. Respondemos en menos de 24 horas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-5 sm:py-14 bg-transparent border-t border-gray-800" data-id="element-65">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-66">
        <div className="text-center mb-4 sm:mb-8" data-id="element-67">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-3" data-id="element-68">
            Preguntas <span className="text-[#D4A843]" data-id="element-69">Frecuentes</span>
          </h2>
          <p className="text-sm sm:text-base text-gray-400" data-id="element-70">
            Todo lo que necesitás saber sobre el kit antes de empezar.
          </p>
        </div>
        <div className="space-y-2.5 sm:space-y-3" data-id="element-71">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`bg-[#1a1512] border rounded-xl overflow-hidden transition-all duration-300 cursor-pointer ${isOpen ? 'border-[#D4A843] ring-1 ring-[#D4A843]/30' : 'border-gray-700/50 hover:border-gray-500'}`} onClick={() => handleToggle(index)} data-id="element-72">
                <div className="p-3 sm:p-5 flex items-center justify-between gap-3" data-id="element-73">
                  <h3 className="text-sm sm:text-base font-bold text-white leading-snug" data-id="element-74">
                    {faq.q}
                  </h3>
                  <div className="text-gray-400 flex-shrink-0" data-id="element-75">
                    {isOpen ? <ChevronUpIcon size={20} className="text-[#D4A843]" data-id="element-76" /> : <ChevronDownIcon size={20} data-id="element-77" />}
                  </div>
                </div>
                <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 pb-3 sm:pb-5 px-3 sm:px-5' : 'max-h-0 opacity-0 px-3 sm:px-5'}`} data-id="element-78">
                  <div className="h-px bg-gray-700/50 mb-3" data-id="element-79"></div>
                  <p className="text-sm sm:text-base text-gray-300 leading-relaxed" data-id="element-80">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}